import {
  ArrowLeft,
  BadgeDollarSign,
  Bot,
  Check,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  Info,
  Sparkles,
  X,
} from "lucide-react";

export const Icons = {
  Default: Info,
  Info: Info,
  Warning: CircleAlert,
  Success: BadgeDollarSign,
  Dismiss: X,
  ArrowLeft: ArrowLeft,
  Back: ChevronLeft,
  Check: Check,
  Forward: ChevronRight,
  Sparkles: Sparkles,
  CircleAlert: CircleAlert,
  BadgeDollarSign: BadgeDollarSign,
  AI: Bot,
};
